import { useNavigate } from "react-router-dom";
import GlobalPopupContainerCenter from "../../../components/globalPopup/GlobalPopupContainerCenter";
import {
    ViewListingNotFoundWrapper,
    ViewListingNotFoundIcon,
    ViewListingNotFoundTitle,
    ViewListingNotFoundSubtitle
} from "../viewListingStyling";

export default function ViewListingNotFound({ closePopup }: { closePopup: () => void }) {
    const navigate = useNavigate();

    const handleReturnHome = () => {
        navigate('/');
    };

    return (
        <GlobalPopupContainerCenter closePopup={closePopup} handleSave={handleReturnHome} btnText="Return to home" noCancelBtn noBackBtn>
            <ViewListingNotFoundWrapper>
                <ViewListingNotFoundIcon src={"https://d292awxalydr86.cloudfront.net/Universal+icons/alert+circle.svg"} alt="not found icon" />
                <ViewListingNotFoundTitle>Listing not found</ViewListingNotFoundTitle>
                <ViewListingNotFoundSubtitle>The listing you're looking for is unavailable or has been removed.</ViewListingNotFoundSubtitle>
            </ViewListingNotFoundWrapper>
        </GlobalPopupContainerCenter>
    );
} 